class HotKey {
  constructor (el) {
    this.el = el || this.findDom()
  }

  /**
   * 优先级
   * 1、当前打开的嵌套弹框
   * 2、当前打开的顶层弹框
   * 3、内容区域
   */
  findDom () {
    // 检查页面是否有激活的message-box，有则快捷键全部失效
    let messageBox = document.querySelector('.el-message-box__wrapper:not([style*="display: none"])')
    if (!messageBox) {
      // 检查是否有禁用快捷键的dialog，有则使用主页面的快捷键
      let disabledKeyDialog = document.querySelector('.el-dialog__wrapper:not([style*="display: none"]) .el-dialog__body div[data-disabled-key="true"]')
      let domList = document.querySelectorAll('.el-dialog__wrapper[append-to-body]:not([style*="display: none"])')
      let dom = domList.length && domList[domList.length - 1]

      if (!disabledKeyDialog && dom) {
        return dom
      }

      dom = document.querySelectorAll('.el-dialog__wrapper:not([style*="display: none"])')

      if (!disabledKeyDialog || (dom && dom.length > 1)) {
        let arr = Array.from(dom)
        // 有禁用快捷键的dialog，且与其他弹窗同时打开时，将其过滤掉
        if (disabledKeyDialog) {
          arr = arr.filter(d => !d.querySelector('.el-dialog__body div[data-disabled-key="true"]'))
        }
        if (arr.length) {
          return arr[arr.length - 1]
        }
      }

      return document.querySelector('.el-main.main-panel')
    }
  }

  getHotKeys () {
    let list = []

    if (this.el) {
      let button = this.el.getElementsByTagName('button')
      let a = this.el.getElementsByTagName('a')
      list = Array.from(button).concat(Array.from(a))
    }

    if (!list.length) {
      return []
    }

    return list.reduce((a, b) => {
      if (b.getAttribute('hotkey')) {
        a.push({
          element: b,
          hotkey: b.getAttribute('hotkey'),
          border: window.getComputedStyle(b, false).border
        })
      }
      return a
    }, [])
  }

  formatHotKey (str) {
    str = str || ''
    return str.replace(/\s+/g, '').toUpperCase()
  }

  handleHotKey (hotkey) {
    let hotkeys = this.getHotKeys()
    for (let key of hotkeys) {
      if ((this.formatHotKey(key.hotkey) === this.formatHotKey(hotkey)) && key.element.getBoundingClientRect().width !== 0) {
        this.fireHotKey(key.element, key.border)
        break
      }
    }
  }

  fireHotKey (element, border) {
    if (!element.offsetParent || element.disabled) {
      return
    }
    document.activeElement && document.activeElement.blur()
    let clickEvent = new MouseEvent('click')
    element.style.border = '2px solid #f0976a'
    window.setTimeout(function () {
      window.__ERP_LASTEVENT__ = element.textContent || ''
      document.dispatchEvent(new MouseEvent('mousedown'))
      element.dispatchEvent(clickEvent)
      element.style.border = border
    }, 50)
  }
  initMarkers (ele) {
    let element = ele.element
    let rect = element.getClientRects()[0]
    if (!rect) {
      return
    }
    let div = document.createElement('div')
    let span = document.createElement('span')
    span.textContent = this.formatHotKey(ele.hotkey)
    span.style.fontWeight = 'bold'
    div.style.top = rect.top + 'px'
    div.style.left = rect.left + 'px'
    div.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 3px 7px 0px'
    div.style.position = 'absolute'
    div.style.padding = '2px 3px'
    div.style.borderRadius = '2px'
    div.style.backgroundColor = 'rgb(227, 190, 35)'
    div.style.zIndex = 100000
    div.className = 'hotkeymarkers'
    div.appendChild(span)
    document.body.appendChild(div)
  }

  showMarkers () {
    let hotkeys = this.getHotKeys()
    hotkeys.map(e => this.initMarkers(e))
  }

  toggleMarkers () {
    let markers = document.getElementsByClassName('hotkeymarkers')
    if (markers.length) {
      let list = Array.from(markers)
      list.forEach(function (element) {
        document.body.removeChild(element)
      })
    } else {
      this.showMarkers()
    }
  }
}

const PREVENTS = [
  'ctrl+ArrowLeft',
  'ctrl+ArrowRight',
  'ctrl+ArrowUp',
  'ctrl+ArrowDown',
  'ctrl+d', // 修改、删除
  'ctrl+f', // 打开通用查询弹框
  // 'ctrl+g',
  'ctrl+o', // 新增
  'ctrl+q', // 通用查询搜索
  'ctrl+r', // 刷新
  'ctrl+s' // 保存
]

const ARROW = {
  ArrowLeft: '←',
  ArrowRight: '→',
  ArrowUp: '↑',
  ArrowDown: '↓'
}

function keydownEvent (e, el) {
  // shift+i
  // if (e.shiftKey && e.keyCode === 73) {
  //   new HotKey(el).toggleMarkers()
  //   return
  // }

  // 左上右下:37-40  0-9: 48-57  a-z: 65-90
  if (e.keyCode < 37 || e.keyCode > 90) {
    return
  }

  let key = ''
  if (e.ctrlKey || e.metaKey) {
    if (PREVENTS.includes('ctrl+' + e.key)) {
      e.preventDefault()
    }
    key = 'ctrl+' + (ARROW[e.key] || e.key)
  } else if (e.altKey) {
    key = 'alt+' + e.code.toLowerCase().replace('key', '')
  }
  if (key) {
    // Ctrl+W 关闭当前标签页或弹出式窗体
    // Ctrl+N 打开新窗体
    // Ctrl+T 打开新标签页
    // [W, N, T, E] 四种无法阻止默认行为
    new HotKey(el).handleHotKey(key)
  }
}

/* eslint-disable-next-line */
if (!process.env.IS_REMOTE_MODULE) {
  document.addEventListener('keydown', keydownEvent)
}

export default keydownEvent



// WEBPACK FOOTER //
// ./src/public/utils/hotkey.js